import { render, staticRenderFns } from "./bea-list-add.vue?vue&type=template&id=0c6fd5df&scoped=true&"
import script from "./bea-list-add.vue?vue&type=script&lang=js&"
export * from "./bea-list-add.vue?vue&type=script&lang=js&"
import style0 from "./bea-list-add.vue?vue&type=style&index=0&id=0c6fd5df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6fd5df",
  null
  
)

export default component.exports